<form class="max-w-xs mx-auto" name="quantity">
    <ng-container *ngIf="label">
        <label for="quantity-input" class="block text-sm font-medium text-gray-700">
            {{ label }}
        </label>
    </ng-container>
    <div class="relative flex items-center max-w-[8rem] ">
        <button *ngIf="!hideButtons" type="button"
                class="bg-gray-100 hover:bg-gray-200 border border-gray-300 border-r-0 rounded-s-sm p-2 h-[38px] focus:ring-gray-100 focus:ring-2 focus:outline-none"
        (click)="decrement()">
            <fa-icon [icon]="iconMinus" size="xs"></fa-icon>
        </button>
        <input type="text" name="quantity" id="quantity-input"
               [ngModel]="value" (ngModelChange)="updateValue($event)"
               [disabled]="disabled"
               [min]="min" [max]="max" [placeholder]="placeholder"
               data-input-counter
               class="block w-10 h-[38px] py-2.5 px-1 z-10 bg-gray-50 border-gray-300  text-center text-gray-900 text-sm focus:ring-primary-700 focus:border-primary-700"
               placeholder="999" required />

        <button *ngIf="!hideButtons" type="button"
                class="bg-gray-100 hover:bg-gray-200 border border-gray-300 border-l-0 rounded-e-sm p-2 h-[38px] focus:ring-gray-100 focus:ring-2 focus:outline-none"
        (click)="increment()">
            <fa-icon [icon]="iconPlus" size="xs"></fa-icon>
        </button>
    </div>
</form>
